// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { AssessmentModule } from '../../../../../types/Model';

import { S } from './styles';

interface AssessmentPrologueProps {
  name: AssessmentModule['name'];
  handleStartAssessment: () => void;
  handleNextModule: () => void;
}

const Prologue: React.FC<AssessmentPrologueProps> = ({
  handleStartAssessment,
  handleNextModule,
  name
}):JSX.Element => {
  return (
    <S.Container>
      <S.InformationContainer>
        <S.AssessmentImage />
        <S.Title>{name}</S.Title>
        <S.Subtitle><FormattedMessage id="F026" /></S.Subtitle>
        <S.Row>
          <S.TextButton onClick={handleNextModule}><FormattedMessage id="F027" /></S.TextButton>
          <S.Button onClick={handleStartAssessment}><FormattedMessage id="F028" /></S.Button>
        </S.Row>
      </S.InformationContainer>
    </S.Container>
  );
}

export { Prologue as default };
